import { ForgeChallenge, SideQuest } from '../types';

export const forgeChallenge: ForgeChallenge = {
  id: 'forge-main',
  type: 'forge',
  title: 'forge.one.demo.tracetronic.com is ready to use',
  description: 'There is no else.',
  rules: [
    'region: eu-central-1',
    'state is in S3',
    'IaC and values are in GitLab',
    'Credentials are shared to Simon via Mail'
  ],
  isCompleted: false
};

export const sideQuests: SideQuest[] = [
  {
    id: 'side-1',
    type: 'side-quest',
    isOptional: true,
    title: 'the understanding of the demo delivery is improved',
    description: 'Checked during Checkout',
    isCompleted: false
  },
  {
    id: 'side-2',
    type: 'side-quest',
    isOptional: true,
    title: 'europe.one.demo.tracetronic.com',
    description: 'infrastructure exists in eu-central-1',
    isCompleted: false
  },
  {
    id: 'side-3',
    type: 'side-quest',
    isOptional: true,
    title: 'america.one.demo.tracetronic.com',
    description: 'infrastructure exists in us-east-1',
    isCompleted: false
  },
  {
    id: 'side-4',
    type: 'side-quest',
    isOptional: true,
    title: 'asia.one.demo.tracetronic.com',
    description: 'infrastructure exists in ap-northeast-2',
    isCompleted: false
  }
  ,
  {
    id: 'side-5',
    type: 'side-quest',
    isOptional: true,
    title: 'a checklist for completeness of the demo deployment is created',
    description: 'has to be defined on post-its and fulfilled for the forge instance',
    isCompleted: false
  }
];
